// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ResizeIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ResizeIcon" ref={forwardedRef} {...props}>
      <path d="m8 16.5 8.485-8.485 1.238 1.237-8.486 8.485z" />
      <path d="M3 16 16.081 2.919l1.238 1.237L4.237 17.237z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ResizeIcon = /* @__PURE__ */ Object.assign(ResizeIconComponent, {
  displayName: 'ResizeIcon',
});
